import dayjs from "dayjs";

//расчет профита по сделке
export const calcProfit = (
  priceOpenOrder: string,
  priceAdd1Order: string | undefined,
  priceAdd2Order: string | undefined,
  priceCloseOrder: string
): string => {
  let profitStr = "";
  let averagePricePositions = 0;
  let sum = 0;
  let count = 0;
  sum += parseFloat(priceOpenOrder);
  count += 1;
  if (priceAdd1Order) {
    sum += parseFloat(priceAdd1Order);
    count += 1;
  }
  if (priceAdd2Order) {
    sum += parseFloat(priceAdd2Order);
    count += 1;
  }
  averagePricePositions = sum / count;
  const profit =
    Math.round(((parseFloat(priceCloseOrder) - averagePricePositions) / (averagePricePositions / 100)) * 100) / 100;
  if (profit >= 0) {
    if (profit >= 10) {
      profitStr = `+${profit.toFixed(0)}`;
    } else {
      profitStr = `+${profit.toFixed(1)}`;
    }
  } else {
    if (profit <= -10) {
      profitStr = `${profit.toFixed(0)}`;
    } else {
      profitStr = `${profit.toFixed(1)}`;
    }
  }

  return profitStr;
};

/**
 * рандомный выбор числа от 1 до to включительно
 */
export const getRandom = (to: number) => {
  return Math.floor(Math.random() * to) + 1;
};

/**
 * рандомная генерация трансформации канвас чтобы убрать повторяемость
 */
export const getRandomTransformCanvas = (): { widthRatio: number; heightRatio: number } => {
  const x = (10000 - getRandom(100)) / 10000; //от 1 до 0,99 т.е 1%
  const y = (10000 - getRandom(100)) / 10000;
  const transform = { widthRatio: x, heightRatio: y };

  return transform;
};

/**
 * Функция для подсчёта количества календарных дней сделки
 * @param {string} start - дата начала в формате YYYY-MM-DD
 * @param {string} end - дата конца в формате YYYY-MM-DD
 * @returns {number} - количество дней (включая день открытия и закрытия)
 */
export const getDaysBetween = (start: string, end: string) => {
  const startDate = dayjs(start, "YYYY-MM-DD");
  const endDate = dayjs(end, "YYYY-MM-DD");
  return endDate.diff(startDate, "day") + 1;
};

//выбор человеко понятной единици времени нахождения в сделке по кличеству дней
export const chooseUnitFromDays = (totalDays: number) => {
  const d = Math.max(1, Math.round(totalDays));
  if (d <= 6) return { n: d, unit: "day" };
  if (d < 28) return { n: Math.max(1, Math.round(d / 7)), unit: "week" };
  return { n: Math.max(1, Math.round(d / 30)), unit: "month" };
};

//получение правильной формы времени в русском языке (в остальных только мн и ед число), например 1 день, 2 дня, 2 дня, но 5 дней
export const ruForm = (n: number, [one, few, many]: string[]) => {
  const n10 = n % 10,
    n100 = n % 100;
  if (n10 === 1 && n100 !== 11) return one;
  if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few;
  return many;
};

//конкретная форма продолжительности в сделке, готовая ко вставке в заголовок, например "за 5 дней"
export const formatWhen = (lang: string, n: number, unit: string) => {
  switch (lang) {
    case "ru": {
      // после «за» — формы счёта (учли «неделю»)
      const dict = {
        day: ["День", "Дня", "Дней"],
        week: ["Неделю", "Недели", "Недель"],
        month: ["Месяц", "Месяца", "Месяцев"],
      };
      const word = ruForm(n, dict[unit as keyof typeof dict]);
      return `${n} ${word}`;
    }
    case "en": {
      const map = {
        day: n === 1 ? "Day" : "Days",
        week: n === 1 ? "Week" : "Weeks",
        month: n === 1 ? "Month" : "Months",
      };
      return `${n} ${map[unit as keyof typeof map]}`;
    }
    case "es": {
      const map = {
        day: n === 1 ? "Día" : "Días",
        week: n === 1 ? "Semana" : "Semanas",
        month: n === 1 ? "Mes" : "Meses",
      };
      return `${n} ${map[unit as keyof typeof map]}`;
    }
    case "pt": {
      const map = {
        day: n === 1 ? "Dia" : "Dias",
        week: n === 1 ? "Semana" : "Semanas",
        month: n === 1 ? "Mês" : "Meses",
      };
      return `${n} ${map[unit as keyof typeof map]}`;
    }
    case "de": {
      // кратко и читаемо в ленте
      const map = {
        day: n === 1 ? "Tag" : "Tagen",
        week: n === 1 ? "Woche" : "Wochen",
        month: n === 1 ? "Monat" : "Monaten",
      };
      return `${n} ${map[unit as keyof typeof map]}`;
    }
    case "fr": {
      const map = { day: n === 1 ? "Jour" : "Jours", week: n === 1 ? "Semaine" : "Semaines", month: "Mois" }; // «mois» = инвариант
      return `${n} ${map[unit as keyof typeof map]}`;
    }
    default: {
      // fallback EN
      const map = {
        day: n === 1 ? "Day" : "Days",
        week: n === 1 ? "Week" : "Weeks",
        month: n === 1 ? "Month" : "Months",
      };
      return `${n} ${map[unit as keyof typeof map]}`;
    }
  }
};

//подстановка в шаблон hook-заголовка конкретных значений
export const formatHook = (template: string, company: string, ticker: string, duration: string, lang: string) => {
  let title = template;

  //меняем в шаблоне стандартный 2 Months на реальную продолжительность
  const durationFormat = `<span data-accent="duration">${duration}</span>`;
  if (lang === "en") {
    title = title.replace("2 Months", durationFormat);
  } else if (lang === "ru") {
    title = title.replace("2 Месяца", durationFormat);
  } else if (lang === "es") {
    title = title.replace("2 Meses", durationFormat);
  } else if (lang === "pt") {
    title = title.replace("2 Meses", durationFormat);
  } else if (lang === "de") {
    title = title.replace("2 Monaten", durationFormat);
  } else if (lang === "fr") {
    title = title.replace("2 Mois", durationFormat);
  }

  //меняем в шаблоне стандартный эмодзи 🔥 в середине на нужный и в нужном положении в тексте
  const emojiPosition = getRandomEmojiPosition();
  const emoji = getRandomEmoji();
  const emojiFormat = `<span data-accent="emoji">${emoji}</span>`;
  if (emojiPosition === "None") {
    title = title.replace("🔥 ", "");
  } else if (emojiPosition === "Start") {
    title = title.replace("🔥 ", "");
    title = emojiFormat + " " + title;
  } else if (emojiPosition === "Center") {
    title = title.replace("🔥", emojiFormat);
  } else if (emojiPosition === "End") {
    title = title.replace("🔥 ", "");
    title = title + " " + emojiFormat;
  }

  //меняем в шаблоне стандартную компанию Apple Inc на нужную и в рандомном из трех вариантов написаний
  const companyTypeOfWriting = getRandomCompanyTypeOfWriting();
  const companyWithoutDot = company.endsWith(".") ? company.slice(0, -1) : company;
  if (companyTypeOfWriting === "Company") {
    const companyFormat = `<span data-accent="company">${companyWithoutDot}</span>`;
    title = title.replace("Apple Inc", companyFormat);
  } else if (companyTypeOfWriting === "Ticker") {
    const tickerFormat = `<span data-accent="ticker">${ticker}</span>`;
    title = title.replace("Apple Inc", tickerFormat);
  } else if (companyTypeOfWriting === "Both") {
    const companyFormat = `<span data-accent="company">${companyWithoutDot}</span>`;
    const tickerFormat = `(<span data-accent="ticker">${ticker}</span>)`;
    title = title.replace("Apple Inc", companyFormat + " " + tickerFormat);
  }

  return title;
};

//Положение эмодзи в тексте заголовка
export type EmojiPosition = "None" | "Start" | "Center" | "End";

//Выдача рандомного положения эмодзи в тексте заголовка
export const getRandomEmojiPosition = (): EmojiPosition => {
  const rand = Math.random() * 100; // от 0 до 100

  if (rand < 40) return "None"; // 40% вероятность
  if (rand < 60) return "Start"; // 20% вероятность
  if (rand < 80) return "Center"; // 20% вероятность
  return "End"; // 20% вероятность
};

export const getRandomEmoji = (): string => {
  const emojiList = ["💭", "⏳", "🕓", "📅", "☕️", "📈", "📊", "🧩", "⚙️", "🔍", "🧭", "🌤️", "🪶", "📎", "🧠"];
  const index = Math.floor(Math.random() * emojiList.length);
  return emojiList[index];
};

//Варианты написания компании
type CompanyTypeOfWriting = "Company" | "Ticker" | "Both";

//Выдача рандомного варианта написания компании в тексте заголовка
export const getRandomCompanyTypeOfWriting = (): CompanyTypeOfWriting => {
  const rand = Math.random() * 100; // от 0 до 100

  if (rand < 50) return "Company"; // 50% вероятность
  if (rand < 70) return "Ticker"; // 20% вероятность
  return "Both"; // 30% вероятность
};
